import BaseCheckbox from "../baseComponents/baseCheckbox";
import BaseParagraph from "../baseComponents/baseParagraph";
import BaseHyperlink from "../baseComponents/baseHyperlink";
import useColors from "../customHooks/useColors";
import { useSelector } from "react-redux";
import BaseRequiredMark from "../baseComponents/BaseRequiredMark";

const ApplicationRulesCheckbox = ({
  value,
  onChange = () => {},
  disabled = false,
}) => {
  const [currentColors] = useColors();

  const systemState = useSelector((state) => state.systemState);

  const rulesLink = systemState.settings.rules_link;

  return (
    <BaseCheckbox value={value} onChange={onChange} disabled={disabled}>
      <BaseParagraph>acceptRules</BaseParagraph>
      <span> </span>
      <BaseHyperlink href={rulesLink}>rules</BaseHyperlink>
      <BaseParagraph>acceptRules2</BaseParagraph>
      {systemState.settings.req_permission1 && <BaseRequiredMark />}
    </BaseCheckbox>
  );
};

export default ApplicationRulesCheckbox;
